import mixpanel from 'mixpanel-browser';

mixpanel.init('4169a4e38679ed49785b430a1049238e');

type Track = {
  name: string,
  props?: object,
};

const ENV_CHECK = process.env.NODE_ENV === 'production';

const actions = {
  identifyMixpanelUser: (email: string):void => {
    if (ENV_CHECK) {
      mixpanel.identify(email);
      mixpanel.people.set({ $email: email });
    }
  },
  track: ({ name, props }:Track):void => {
    if (ENV_CHECK) mixpanel.track(name, props);
  },
};

export const mixpanelEvent = actions;
